<template>
  <template v-if="appReady">
    <RouterView />
    <SiteFooter />
    <BottomBar/>
    <Modal/>
    <Gdpr :options="{backgroundColor: '#242424', color: '#fff'}"/>
  </template>
  <Transition name="fade">
    <Loader v-if="!appReady"/>
  </Transition>
</template>

<script>
import {useLangRouter} from '@/extensions/langRouter'
import Gdpr from '@/components/gdpr/Gdpr.vue'
import {Modal} from '@/components/modal'
import {BottomBar} from '@/components/navigation'
import {SiteFooter} from '@/components/sections'
import {Loader} from '@/components/small'

export default {
  name: 'App',
  setup() {
    useLangRouter()
  },
  components: {BottomBar, Gdpr, Loader, Modal, SiteFooter},
  data() {
    return {
      appReady: false
    }
  },
  watch: {
    '$i18n.locale': {
      handler: async function (to) {
        await this.$beet.fetchCoreData(to)
        await this.$store.dispatch('setLocations', Object.values(this.$beet.locations))
        await this.$store.dispatch('setOffers', Object.values(this.$beet.jobOffers))
        await this.$store.dispatch('setTypes', Object.values(this.$beet.jobTypes))
        await this.$store.dispatch('setCompanies', Object.values(this.$beet.companies))
        await this.$store.dispatch('init')
        this.appReady = true
      },
      immediate: true
    }
  },
  updated() {
    this.$nextTick(() => {
      const el = this.$route.hash ? document.querySelector(this.$route.hash) : null
      el ?
          el.scrollIntoView({behavior: 'smooth', block: 'start'}) :
          window.scrollTo({top: 0, behavior: 'smooth'})
    })
  }
}
</script>
